/*
 * Sticky "Join the waitlist" button (snippets/waitlist-sticky.liquid), plus any link to
 * #join-waitlist, which scrolls to the hero signup the same way.
 * Shows once the hero signup has scrolled out of view, hides while any signup form is
 * on screen, and stays hidden for the rest of the session after a successful signup.
 */
(() => {
  const button = document.querySelector('[data-waitlist-sticky]');
  const forms = Array.from(document.querySelectorAll('.email-signup-block'));
  const heroForm = document.querySelector('.can-stage--hero .email-signup-block') || forms[0];
  const STORAGE_KEY = 'crave-waitlist-joined';

  if (!heroForm) return;

  /** Scrolls to the hero signup and puts the cursor in the email field. */
  const goToSignup = () => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const input = heroForm.querySelector('input[type="email"]');

    heroForm.scrollIntoView({ behavior: reduceMotion ? 'instant' : 'smooth', block: 'center' });
    if (input instanceof HTMLElement) input.focus({ preventScroll: true });
  };

  // Any link to #join-waitlist (e.g. the story section button) behaves like the sticky button.
  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest('a[href$="#join-waitlist"]') : null;
    if (!link) return;
    event.preventDefault();
    goToSignup();
  });

  if (!button || !('IntersectionObserver' in window)) return;

  const storage = {
    get() {
      try {
        return window.sessionStorage.getItem(STORAGE_KEY) === '1';
      } catch (error) {
        return false;
      }
    },
    set() {
      try {
        window.sessionStorage.setItem(STORAGE_KEY, '1');
      } catch (error) {
        // Storage can be blocked (private mode); the button then only hides for this page.
      }
    },
  };

  // After a successful signup Shopify reloads the page with a success message in the form.
  const justJoined =
    document.querySelector('[id^="Email-signup__message-success"]') !== null ||
    new URLSearchParams(window.location.search).get('customer_posted') === 'true';
  if (justJoined) storage.set();
  if (justJoined || storage.get()) return;

  button.hidden = false;

  const onScreen = new Set();
  let heroPassed = false;

  const update = () => {
    button.classList.toggle('is-visible', heroPassed && onScreen.size === 0);
  };

  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        onScreen.add(entry.target);
      } else {
        onScreen.delete(entry.target);
      }

      // "Passed" means the hero form has left through the top of the screen.
      if (entry.target === heroForm) {
        heroPassed = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
      }
    }
    update();
  });

  for (const form of forms) observer.observe(form);
  if (!forms.includes(heroForm)) observer.observe(heroForm);

  button.addEventListener('click', goToSignup);
})();
